import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propShape, propStr, propValidate, } from '../../../helpers/custom-prop-types';
import MultiInputFields from '../Common/Fields/MultiInputFields';
const ZipCodeFields = ({ form, name1, name2, validate1, validate2 }) => (_jsx(MultiInputFields, { className: 'input-form-text is-onethird', form: form, settings: [
        {
            maxLength: 3,
            name: name1,
            placeholder: '000',
            type: 'tel',
            validate: validate1,
        },
        {
            maxLength: 4,
            name: name2,
            placeholder: '0000',
            type: 'tel',
            validate: validate2,
        },
    ] }));
ZipCodeFields.propTypes = {
    form: propShape().isRequired,
    name1: propStr(),
    name2: propStr(),
    validate1: propValidate().isRequired,
    validate2: propValidate().isRequired,
};
ZipCodeFields.defaultProps = {
    name1: 'zipCode1',
    name2: 'zipCode2',
};
export default ZipCodeFields;
